import React from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';

const Modal = (props) => {
    const modalElement = props.show
        ?
        (<div className={css.modalBackdrop}>
            <div className={css.modal}>
                {props.children}
            </div>
        </div>)
        : null;

    return modalElement;
};

Modal.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.node
};

export default Modal;



// WEBPACK FOOTER //
// ./components/modal/index.js